export const share = {
  namespaced: true,

  state: {
    url: '',
    title: '',
    text: '',
    imageUrl: '',
  },

  mutations: {
    SET_URL(state, payload) {
      state.url = payload;
    },

    SET_TEXT(state, payload) {
      state.title = payload;
    },

    SET_TITLE(state, payload) {
      state.text = payload;
    },

    SET_IMAGE_URL(state, payload) {
      state.imageUrl = payload;
    },
  },

  actions: {
    show({ commit }, { url = '', title = '', text = '', imageUrl = '' }) {
      commit('SET_URL', url);
      commit('SET_TITLE', title);
      commit('SET_TEXT', text);
      commit('SET_IMAGE_URL', imageUrl);
    },

    hide({ commit }) {
      commit('SET_URL', '');
      commit('SET_TITLE', '');
      commit('SET_TEXT', '');
      commit('SET_IMAGE_URL', '');
    },
  },

  getters: {
    shows: (state) => Boolean(state.url),
    url: (state) => state.url,
    title: (state) => state.title,
    text: (state) => state.text,
    imageUrl: (state) => state.imageUrl,
  },
};

export default share;
